import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { QrGeneratorModalPage } from './qr-generator-modal';

@NgModule({
  declarations: [
    QrGeneratorModalPage,
  ],
  imports: [
    IonicPageModule.forChild(QrGeneratorModalPage),
  ],
})
export class QrGeneratorModalPageModule {}



// WEBPACK FOOTER //
// ./src/pages/qr-generator-modal/qr-generator-modal.module.ts